import React, { Component } from 'react';
import PropTypes from 'prop-types';
import UserContext from '../../pages/layout/UserContext';
import checkPermission from './Util';

class Authorized extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { children } = this.props;
    const { asset, operation } = this.props;
    return (
      <UserContext.Consumer>
        {value => {
          return value && checkPermission(value, asset, operation) && children;
        }}
      </UserContext.Consumer>
    );
  }
}

Authorized.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  children: PropTypes.object,
  asset: PropTypes.object,
  operation: PropTypes.object,
};

export default Authorized;
